import { observable } from "mobx";
import ChargeValidity from "./chargeValidity";
import Enum from "models/enum";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeTypeResponse extends Enum {
  /**
   * Charge type ID.
   */
  id!: string;

  @observable
  validFor!: ChargeValidity;

  /**
   * Localized charge type description.
   */
  @observable
  description!: string;

  /**
   * Notify days before.
   */
  @observable
  notifyDaysBefore?: number;

  /**
   * Indicates whether charge type is deleted.
   */
  @observable
  isDeleted!: boolean;

  @observable
  _standardPrice?: number = 0;

  @observable
  _ecoPriceMin?: number = 0;

  @observable
  _ecoPriceMax?: number = 0;
}
